import NavigationHoverItem from "../../NavigationHoverItem";
import EcosystemItems from "../../EcosystemItems";
import CommunityItems from "../../CommunityItems";
import AboutItems from "../../AboutItems";
import EcosystemIcon from "assets/landing/icons/burger-icons/EcosystemIcon";
import CommunityIcon from "assets/landing/icons/burger-icons/CommunityIcon";
import AboutIcon from "assets/landing/icons/burger-icons/AboutIcon";

const Navigation = () => {
  return (
    <nav className="lg:block hidden">
      <ul className="flex gap-[0.65vw]">
        <li>
          <NavigationHoverItem
            cardTrigger={
              <div className="navigation-link py-[0.65vw] pr-[1.1vw] pl-[0.65vw] outline-none flex items-center gap-[0.8vw] rounded-2xl">
                <div className="size-[2vw] flex items-center justify-center rounded-lg bg-white shadow-custom">
                  <div className={"ml-[0.05vw]"}>
                    <EcosystemIcon className={"size-[1.4vw] "} />
                  </div>
                </div>
                <span className="text-black text-[1vw] leading-[1.1] font-luxora-regular">
                  Ecosystem
                </span>
              </div>
            }
            cardList={<EcosystemItems />}
          />
        </li>
        <li>
          <NavigationHoverItem
            cardTrigger={
              <div className="navigation-link py-[0.65vw] pr-[1.1vw] pl-[0.65vw] outline-none flex items-center gap-[0.8vw] rounded-2xl">
                <div className="size-[2vw] flex items-center justify-center rounded-lg bg-white shadow-custom">
                  <div>
                    <CommunityIcon className={"size-[1.4vw] "} />
                  </div>
                </div>
                <span className="text-black text-[1vw] leading-[1.1] font-luxora-regular">
                  Community
                </span>
              </div>
            }
            cardList={<CommunityItems />}
          />
        </li>
        <li>
          <NavigationHoverItem
            cardTrigger={
              <div className="navigation-link py-[0.65vw] pr-[1.1vw] pl-[0.65vw] outline-none flex items-center gap-[0.8vw] rounded-2xl">
                <div className="size-[2vw] flex items-center justify-center rounded-lg bg-white shadow-custom">
                  <div>
                    <AboutIcon className={"size-[1.3vw]"} />
                  </div>
                </div>
                <span className="text-black text-[1vw] leading-[1.1] font-luxora-regular">
                  About
                </span>
              </div>
            }
            cardList={<AboutItems />}
          />
        </li>
      </ul>
    </nav>
  );
};

export default Navigation;
